
import React, { useEffect, useState } from 'react';
import { api_bd_nr } from '../../services/Api.js';
import settingsIcon from './images/settings.svg';
import ModalStateLess from '../ModalStateLess/index.js';
import ChartRanking from './ChartRanking.js';
import Avatar from './Avatar.js';
import Form from './Form.js';
import ConfigChart from './ConfigChart.js';
import AdminView from './AdminView.js';
import UserView from './UserView.js';
import DashboardView from './DashboardView';
import PenaltyReport from './PenaltyReport.js';
import { Check, Trash2, Megaphone, Settings } from 'lucide-react'



const PenaltyReportListComponent = ({ data, selectedMonth, refreshData, loggedUser }) => {
    const [infractionList, setInfractionList] = useState(data || [])

    const orderedData = infractionList.sort((a, b) => {
        console.log('opa: \n', b.date, '\n', a.date)
        return (new Date(b.date) - new Date(a.date))
    })

    return (
        <div>
            <h3 className='mb-[30px] text-lg font-bold'>Infrações reportadas anonimamente</h3>

            {orderedData?.length > 0 ? (
                orderedData.map((el, index) => (
                    <div
                        key={`penaltyreport_${index}`}
                        className={`flex flex-row w-full rounded shadow-sm shadow-[#0006] p-3 ${el.readStatus ? 'opacity-[0.4] text-gray-300' : ''}`}
                    >
                        <div
                            className='p-3'
                        >
                            <Megaphone className='w-[40px] h-[40px]' />
                        </div>
                        <div>
                            <p><b>Tipo de infração:</b> {el?.valueInfraction?.name}</p>
                            <p><b>Descrição:</b> {el?.descInfraction}</p>
                            <p><b>Horário:</b> {el?.descInfraction}</p>
                            <p><b>ID do ticket:</b> {el?.idTicket}</p>
                            <button
                                disabled={el.readStatus}
                                className={`flex items-center justify-center mt-3 p-2 w-[150px] bg-blue-900 text-white rounded font-bold ${el.readStatus ? ' bg-gray-400' : ''}`}
                                onClick={() => {
                                    api_bd_nr.put(`/performance-radar/penaltyreport?id=${el._id}`, {
                                        month: selectedMonth,
                                        year: new Date().getFullYear(),
                                        readBy: {
                                            name: loggedUser.nome,
                                            level: loggedUser.nivel,
                                            id: loggedUser.id
                                        }
                                    }).then(() => {
                                        setInfractionList(current => {
                                            const temp = [...current]
                                            return temp.map(infraction => {
                                                if (infraction._id === el._id) {
                                                    return ({
                                                        ...infraction,
                                                        readStatus: true
                                                    })
                                                } else {
                                                    return infraction
                                                }
                                            })
                                        })
                                        if (refreshData) {
                                            refreshData()
                                        }
                                    }).catch(e => {
                                        alert('Ocorreu um erro ao atualizar a informação, tente novamente, caso o erro persistir contate o suporte')
                                    })

                                }}
                            >
                                <span className='m-0'>Marcar como lida</span> <Check className='ml-2 h-[15px]' />
                            </button>

                            <button
                                disabled={el.readStatus}
                                className={`flex items-center justify-center mt-3 p-2 w-[150px] bg-blue-900 text-white rounded font-bold  ${el.readStatus ? ' bg-gray-400' : ''}`}
                                onClick={() => {
                                    if (window.confirm('Deseja realmente excluir este informe de infração?')) {
                                        api_bd_nr.delete(`/performance-radar/penaltyreport?id=${el._id}`, {
                                            data: {
                                                month: selectedMonth,
                                                year: new Date().getFullYear(),
                                            }
                                        }).then(() => {
                                            setInfractionList(current => {
                                                const temp = [...current]
                                                return temp.filter(infraction => {
                                                    return (infraction._id !== el._id)
                                                })
                                            })
                                            if (refreshData) {
                                                refreshData()
                                            }
                                        }).catch(e => {
                                            alert('Ocorreu um erro ao atualizar a informação, tente novamente, caso o erro persistir contate o suporte')
                                        })
                                    }
                                }}
                            >
                                <span className='m-0'>Excluir</span> <Trash2 className='ml-2 h-[15px]' />
                            </button>
                        </div>
                    </div>
                ))
            ) : (
                <span className='m-0 text-lg font-bold'>Nenhuma infração reportada para o período selecionado</span>
            )
            }

        </div >
    )
}


const PerformanceRadar = (props) => {
    const [modalData, setModalData] = useState({ show: false, content: <></>, hideModal: () => { } })
    const [modalData2, setModalData2] = useState({ show: false, content: <></>, hideModal: () => { } })
    const [data, setData] = useState([])
    const [actualMonth, setActualMonth] = useState(new Date().getMonth() + 1)
    const [penalityReportList, setPenalityReportList] = useState([])

    const monthList = [
        { label: "Janeiro", value: 1 },
        { label: "Fevereiro", value: 2 },
        { label: "Março", value: 3 },
        { label: "Abril", value: 4 },
        { label: "Maio", value: 5 },
        { label: "Junho", value: 6 },
        { label: "Julho", value: 7 },
        { label: "Agosto", value: 8 },
        { label: "Setembro", value: 9 },
        { label: "Outubro", value: 10 },
        { label: "Novembro", value: 11 },
        { label: "Dezembro", value: 12 },
    ]

    const closeModal = () => {
        setModalData({ show: false, content: <></>, hideModal: () => { } })
    };

    const closeModal2 = () => {
        setModalData2({ show: false, content: <></>, hideModal: () => { } })
    };

    const openModal = (_content = false) => {
        if (_content) {
            setModalData({ show: true, content: _content, hideModal: closeModal })
        }
    };

    const openModal2 = (_content = false) => {
        if (_content) {
            setModalData2({ show: true, content: _content, hideModal: closeModal2 })
        }
    };

    const saveData = (data, update, month) => {
        const d = new Date()
        const participants = data.map(el => {
            return ({
                ...el,
                name: el.name || el.nome,
                avatar: el.avatar || el.image_profile,
                id: el.id || el._id
            })
        })

        if (update) {
            // console.log({
            //     month,
            //     year: d.getFullYear(),
            //     participants
            // })

            api_bd_nr.put('/performance-radar?q=data', {
                month,
                year: d.getFullYear(),
                participants
            })
                .then(({ data }) => {
                    // console.log('-')
                    loadData()
                })
                .catch((error) => {
                    console.log('save data error: ', error)
                })
        } else {
            api_bd_nr.post('/performance-radar?q=data', {
                month,
                year: d.getFullYear(),
                participants
            })
                .then(({ data }) => {
                    // console.log('data: ', data)
                    loadData()
                })
                .catch((error) => {
                    console.log('save data error: ', error)
                })
        }

    }


    const loadData = () => {
        api_bd_nr.get(`/performance-radar?q=data&m=${actualMonth}`)
            .then(({ data }) => {
                // console.log('data: ', data)
                setPenalityReportList(data?.[0]?.penaltyReport || [])
                const participants = data?.[0]?.participants?.map((el, index) => {
                    return ({
                        ...el,
                        endIcon: (
                            <Avatar
                                src={el.avatar}
                                onClick={() => {
                                    if (props.loggedUser.id === el.id || props.loggedUser.nivel.match(/Super|Técnico-Admin/)) {
                                        openModal(<Form data={el} selectedMonth={actualMonth} loggedUser={props.loggedUser} refreshData={loadData} openModal2={openModal2} closeModal2={closeModal2} />)
                                    } else {
                                        alert('Você não tem permissões para visualizar estas informações.')
                                    }
                                }}
                            />
                        ),
                        dataKey: index,
                        value: (el.infractions.reduce((acc, currentData) => { return (acc + currentData?.point) }, 100) + el.bonuses.reduce((acc, currentData) => { return (acc + currentData?.point) }, 0)),
                        targetValue: 80, amt: 100,
                    })
                })

                // console.log('participants', participants)
                setData(participants || [])
            })
            .catch((error) => {
                console.log('get data error: ', error)
            })
    }

    useEffect(() => {
        loadData()

        const interval = setInterval(() => {
            loadData()
        }, 180000)

        return () => {
            clearInterval(interval)
        }

    }, [actualMonth])

    const mediaVal = data.reduce((acc, currentItem) => {
        return acc + currentItem.value
    }, 0)
    // console.log('mediaVal: ', mediaVal / data.length)

    // console.log('LoggedUser: ', props?.loggedUser)
    // console.log('data: ', data)

    const orderedData = data?.sort((a, b) => {
        if (b.value < a.value) {
            return -1;
        }
        if (b.value > a.value) {
            return 1;
        }

        // names must be equal
        return 0;
    })

    // const isAdminUser = props.loggedUser.nivel.match(/Super|Técnico-Admin/)

    // console.log('props?.loggedUser', props?.loggedUser)

    const filteredData = props?.loggedUser?.nivel === 'Técnico' ? orderedData.filter(el => el.id === props?.loggedUser?.id) : orderedData

    return (
        <div
            style={{
                paddingTop: 20,
                display: 'flex',
                flexDirection: 'column',
                flexFlow: 1,
                width: '100%',
                height: 'calc(100dvh - 50px)',
                minHeight: 'calc(100dvh - 50px)',
                maxHeight: 'calc(100dvh - 50px)'
            }}
        >

            <ModalStateLess  {...modalData} />
            <ModalStateLess addZIndex={5} {...modalData2} />

            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingLeft: 10, paddingRight: 20 }}>
                <div>
                    <span style={{ fontSize: '1.5em' }}>Radar de Desempenho: </span>
                    <select
                        style={{ fontSize: '1.5em' }}
                        value={actualMonth}
                        onChange={(e) => {
                            setActualMonth(parseInt(e.target.value))
                            // loadData()
                        }}
                    >
                        {
                            monthList.map(el => (
                                <option value={el.value}>{el.label}</option>
                            ))
                        }
                    </select>
                </div>

                {props?.loggedUser?.nivel?.match(/Super|Técnico-Admin/) ? (
                    <div className='flex flex-row gap-[50px]'>
                        <div className='relative cursor-pointer'
                            onClick={() => {
                                openModal(<PenaltyReportListComponent selectedMonth={actualMonth} data={penalityReportList} refreshData={() => { loadData() }} loggedUser={props?.loggedUser} />)
                            }}
                        >   {penalityReportList?.filter(el => el.readStatus === false).length > 0 &&
                            <div className='absolute flex justify-center items-center rounded-full bg-red-600 text-white font-bold h-[20px] w-[20px] mt-[-10px] ml-[14px]'>
                                {penalityReportList?.filter(el => el.readStatus === false).length}
                            </div>
                            }
                            <Megaphone />
                        </div>
                        <Settings
                            alt="settings"
                            style={{ width: 30, height: 30, alignSelf: 'flex-end', cursor: 'pointer' }}
                            onClick={() => {
                                openModal(<ConfigChart
                                    selectedMonth={actualMonth}
                                    participantsList={data}
                                    onSaveButtonClick={(val, month) => {
                                        // console.log('save data', data)
                                        saveData(val, data?.length > 0 ? true : false, month)
                                        closeModal()
                                    }}
                                // onChangeParticipantList={(participantsList) => {
                                //     // console.log('lista de participantes, alterada', participantsList)
                                // }}
                                />);
                            }}
                        />
                    </div>
                ) : props?.loggedUser?.nivel === 'Técnico' ? (
                    <PenaltyReport selectedMonth={actualMonth} />
                ) : (<></>)
                }
            </div>

            {props?.loggedUser?.nivel?.match(/Super|Técnico-Admin/) &&
                <AdminView
                    data={{
                        percentageHeight: 70,
                        chartData: data,
                        media: data?.length > 0 ? (mediaVal / data.length) : 0
                    }}
                />
            }

            {filteredData.length === 0 &&
                <div className='w-full flex flex-col mt-[20px] p-4'>
                    <span>Você não está na lista dos participantes do ranking do mês selecionado.</span>
                    <span>Para visualizar informações sobre o ranking <a className='font-bold' href="/nocranking" target='_blank'>clique aqui</a></span>
                </div>
            }

            {props?.loggedUser?.nivel === 'Técnico' &&
                <>

                    <UserView data={{
                        percentageHeight: 80,
                        chartData: filteredData,//data,
                        first: orderedData?.[0] || {},
                        second: orderedData?.[1] || {},
                        third: orderedData?.[2] || {},
                        media: data?.length > 0 ? (mediaVal / data.length) : 0
                    }} />
                </>
            }


        </div>
    );
};

export default PerformanceRadar;
